import firebase from "../../config/firebase";
export const addLoader = (val) => async (dispatch) => {
    dispatch({
        type: "ADD_LOADER",
        payload: val,
    });
};
export const getLoader = (val) => async (dispatch) => {
    dispatch({
        type: "GET_LOADER",
        payload: val,
    });
};
export const addNewDistributer =
    (formData, targetMarket, mapCenter, country, onSuccess = () => {}) =>
    async (dispatch) => {
        dispatch(addLoader(true));
        try {
            firebase
                .firestore()
                .collection("distributer")
                .doc()
                .set({
                    ...formData,
                    targetMarket: targetMarket,
                    coardinates: mapCenter,
                    country: country,
                    createdAt: firebase.firestore.Timestamp.now(),
                })
                .then((data) => {
                    dispatch(addLoader(false));
                    onSuccess();
                    alert("Distributer Added Successfully");
                })
                .catch((e) => {
                    alert(e.message);
                    dispatch(addLoader(false));
                });
        } catch (err) {
            alert(err.message);
            dispatch(addLoader(false));
        }
    };

export const getDistributers = () => async (dispatch) => {
    dispatch(getLoader(true));
    firebase
        .firestore()
        .collection("distributer")
        .onSnapshot((query) => {
            let tempDistributer = [];
            for (let doc of query.docs) {
                tempDistributer.push({
                    id: doc.id,
                    ...doc.data(),
                });
            }
            dispatch({
                type: "GET_DISTRIBUTER",
                payload: tempDistributer,
            });
            dispatch(getLoader(false));
        });
};
